/* V20 — offcanvas navigation drawer (mobile). Plain JS, no dependencies. */
( function () {
	'use strict';

	var nav      = document.getElementById( 'site-nav' );
	var toggler  = document.querySelector( '.nav-toggler' );
	var closeBtn = document.querySelector( '.nav-close' );
	var backdrop = document.querySelector( '.nav-backdrop' );

	if ( ! nav || ! toggler ) {
		return;
	}

	function open() {
		nav.classList.add( 'is-open' );
		toggler.setAttribute( 'aria-expanded', 'true' );
		if ( backdrop ) {
			backdrop.hidden = false;
			// Force reflow so the opacity transition runs.
			void backdrop.offsetWidth;
			backdrop.classList.add( 'is-visible' );
		}
		document.body.style.overflow = 'hidden';
	}

	function close() {
		nav.classList.remove( 'is-open' );
		toggler.setAttribute( 'aria-expanded', 'false' );
		if ( backdrop ) {
			backdrop.classList.remove( 'is-visible' );
			var hide = function () {
				backdrop.hidden = true;
				backdrop.removeEventListener( 'transitionend', hide );
			};
			backdrop.addEventListener( 'transitionend', hide );
		}
		document.body.style.overflow = '';
	}

	toggler.addEventListener( 'click', open );
	if ( closeBtn ) {
		closeBtn.addEventListener( 'click', close );
	}
	if ( backdrop ) {
		backdrop.addEventListener( 'click', close );
	}

	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' && nav.classList.contains( 'is-open' ) ) {
			close();
		}
	} );

	// Mobile: tap a parent item to expand/collapse its submenu.
	var parents = nav.querySelectorAll( '.menu-item-has-children > a' );
	Array.prototype.forEach.call( parents, function ( link ) {
		link.addEventListener( 'click', function ( e ) {
			if ( window.innerWidth >= 992 ) {
				// Desktop uses hover; just stop the "#" jump.
				if ( link.getAttribute( 'href' ) === '#' ) {
					e.preventDefault();
				}
				return;
			}
			e.preventDefault();
			link.parentNode.classList.toggle( 'is-expanded' );
		} );
	} );

	// Reset drawer state when resizing up to desktop.
	window.addEventListener( 'resize', function () {
		if ( window.innerWidth >= 992 && nav.classList.contains( 'is-open' ) ) {
			close();
		}
	} );
}() );
